import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useCallback } from 'react';
import { LoadingSpinner } from '../../web/components/LoadingSpinner';
import { ClockIcon } from '../../web/components/svgs/icons/ClockIcon';
import { LocationPinIcon } from '../../web/components/svgs/icons/LocationPinIcon';
import { grayIconFill } from '../../web/styles/colors';
import { baseStyleSheet } from '../../web/styles/styles';
import { useMeeting } from '../contexts/meeting';
import { ScheduleMeetingHeaderHost } from '../ScheduleMeetingHeaderHost';
import { styleSheet as pageStyles } from '../styles/styles';
import { getDurationText } from '../UiUtils';
import { styleSheet } from './styles';

interface IProps {
	fetching?: boolean;
}

export const ScheduleMeetingHeader = ({ fetching }: IProps) => {
	const { meeting, isReschedule } = useMeeting();

	const renderDuration = useCallback(() => {
		return getDurationText(meeting?.duration);
	}, [meeting?.duration]);

	const renderLocation = useCallback(() => {
		switch (meeting?.location?._type) {
			case Api.MeetingType.Phone:
				return 'I will give you a call.';
			case Api.MeetingType.InPerson:
				return (meeting?.location as Api.IInPersonLocationConfig)?.address;
			case Api.MeetingType.Virtual:
				return 'Virtual (link to be provided upon meeting booking)';
			case Api.MeetingType.AllowInvitee:
				return 'Attendee to choose';
			case Api.MeetingType.Other:
				return (meeting.location as Api.IOtherMeetingLocationConfig).instructions;
			default:
				return '';
		}
	}, [meeting?.location]);

	return (
		<div className={css(pageStyles.header, !fetching && !meeting?.id && baseStyleSheet.flexCenter)}>
			{fetching && <LoadingSpinner className={css(baseStyleSheet.absoluteCenter)} />}
			{!fetching && !meeting?.id && <p className={css(styleSheet.errorMessage)}>An error has occurred.</p>}
			{!fetching && meeting?.id && (
				<>
					<div className={css(pageStyles.headerCol, pageStyles.headerColLeft)}>
						<ScheduleMeetingHeaderHost
							host={meeting?.host}
							company={meeting?.company}
							isReschedule={isReschedule}
							additionalHosts={meeting?.additionalHosts}
						/>
					</div>
					<div className={css(pageStyles.headerCol, pageStyles.headerColRight)}>
						<p className={css(styleSheet.meetingName)}>{meeting?.name}</p>
						<p className={css(styleSheet.labelWithIcon)}>
							<ClockIcon fillColor={grayIconFill} />
							{renderDuration()}
						</p>
						<p className={css(styleSheet.labelWithIcon)}>
							<LocationPinIcon fillColor={grayIconFill} />
							{renderLocation()}
						</p>
					</div>
				</>
			)}
		</div>
	);
};
